import { render } from "./DispatcherComp.vue?vue&type=template&id=04974330&ts=true"
import script from "./DispatcherComp.vue?vue&type=script&lang=ts"
export * from "./DispatcherComp.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__